import {useSelector} from "react-redux";
import TaskDelay from "./task-delay";
import {normalizeMembershipEntity} from "../workspace-membership/workspace-membership-identity";

const delayPopulate = {
    createdBy: {populate: ["profileImage"]},
};

export function useTaskDelay() {
    const {workspaceMembershipData} = useSelector(state => state.app);
    const memberships = workspaceMembershipData?.workspace?.workspace_memberships || [];
    const normalizeDelay = (item) => normalizeMembershipEntity(item, "taskDelay", memberships);

    const getTaskDelays = async (taskId) => {
        if (!taskId) return [];
        try {
            const model = new TaskDelay();
            const query = {
                populate: delayPopulate,
                sort: "createdAt:desc",
                pagination: {pageSize: 100, withCount: false},
            };
            const _data = await model.getTaskDelays(taskId, query);
            return (_data?.data || []).map(normalizeDelay);
        } catch (e) {
            return [];
        }
    };

    const createTaskDelay = async (taskId, delayData) => {
        try {
            const model = new TaskDelay();
            const _data = await model.delay(taskId, delayData);
            return {task: _data?.data ?? _data, warnings: _data?.meta?.warnings || []};
        } catch (e) {
            throw e;
        }
    };

    return {
        getTaskDelays,
        createTaskDelay,
    };
}
